import { Box } from '@mui/material'
import { ReactElement } from 'react'
import TruncatedText from './TruncatedText'
import { AttributeType } from '../../constants/constants'

export type IValueType =
    | 'STRING'
    | 'LINK'
    | 'COMPONENT'
    | AttributeType.SEPARATOR

export interface IKeyValue {
    key: string
    value: string | ReactElement
    type: IValueType
}

interface IKeyValueGrid {
    data: IKeyValue[]
    minWidth?: string
    maxWidth?: string
}
const KeyValueGrid = (props: IKeyValueGrid): ReactElement => {
    const { data, minWidth, maxWidth } = props
    const renderValue = (pair: IKeyValue) => {
        switch (pair.type) {
            case 'COMPONENT':
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {pair.value}
                    </Box>
                )
            case 'LINK':
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {pair.value}
                    </Box>
                )
            default: // 'STRING' or any other cases
                return (
                    <TruncatedText
                        sx={{ fontSize: '14px' }}
                        text={pair.value as string}
                    />
                )
        }
    }
    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                width: '100%',
                '& > *': {
                    flex: `1 1 ${maxWidth ? maxWidth : 'calc(50% - 20px)'}`,
                    maxWidth: maxWidth ? maxWidth : 'calc(50% - 20px)',
                    minWidth: minWidth ? minWidth : '250px',
                    marginBottom: '10px',
                    marginRight: '20px',
                },
            }}
        >
            {data.map((pair) => {
                return (
                    <Box key={pair.key} sx={{ display: 'flex' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <TruncatedText
                                sx={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                }}
                                text={pair.key}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <span
                                style={{
                                    marginLeft: '10px',
                                    marginRight: '8px',
                                }}
                            >
                                {pair.type === AttributeType.SEPARATOR
                                    ? ''
                                    : ':'}
                            </span>
                            {renderValue(pair)}
                        </Box>
                    </Box>
                )
            })}
        </Box>
    )
}

export default KeyValueGrid
